export const toSmallUnit = (price, decimal) => {
    return price / Math.pow(10, decimal);
  };